export const ModuleCompletionStatus = {
  LOCK : 0,
  COMPLETED : 1,
  IN_PROGRESS : 2,
}